import { render, staticRenderFns } from "./ComputerVisionPage.vue?vue&type=template&id=731376db&scoped=true"
import script from "./ComputerVisionPage.vue?vue&type=script&lang=js"
export * from "./ComputerVisionPage.vue?vue&type=script&lang=js"
import style0 from "./ComputerVisionPage.vue?vue&type=style&index=0&id=731376db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731376db",
  null
  
)

export default component.exports